
import React from 'react';
import { Profession } from '@/lib/professionTypes';
import { ScrollArea } from "@/components/ui/scroll-area";
import ProfessionCategoryGroup from './ProfessionCategoryGroup';
import { groupProfessionsByCategory } from './ProfessionUtils';

interface ProfessionListProps {
  loading: boolean;
  professions: Profession[];
  selectedProfessions: string[];
  onProfessionChange: (professionId: string, checked: boolean) => void;
}

const ProfessionList: React.FC<ProfessionListProps> = ({
  loading,
  professions,
  selectedProfessions,
  onProfessionChange
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (professions.length === 0) {
    return (
      <div className="flex justify-center items-center h-full text-muted-foreground">
        Nincs találat a keresési feltételeknek.
      </div>
    );
  }

  const groupedProfessions = groupProfessionsByCategory(professions);

  return (
    <ScrollArea className="h-60 border rounded-md p-2">
      <div className="space-y-4">
        {Object.entries(groupedProfessions).map(([category, profs]) => (
          <ProfessionCategoryGroup
            key={category}
            category={category}
            professions={profs}
            selectedProfessions={selectedProfessions}
            onProfessionChange={onProfessionChange}
          />
        ))}
      </div>
    </ScrollArea>
  );
};

export default ProfessionList;
